import React, { useEffect, useRef } from "react";
import { Row, Col, Drawer, Divider, Space, Modal } from "antd";
import { useForm } from "react-hook-form";
import { LazerOpenModalButton } from "./buttons/LazerOpenModalButton";
import { DamageIndicatorIcon } from "../icons/DamageIndicatorIcon";
import { OrderButton } from "./buttons/OrderButton";
import { Dot } from "./Dot";
import { NotApprovedDrawer } from "../../MyOrders/NotApprovedDrawer";
import order_sent from "../../../img/order_sent.jpg";
import { useSelector } from "react-redux";
import { DeleteOutlined, CloseOutlined } from "@ant-design/icons";
import html2canvas from "html2canvas";
//@ts-ignore
import { useScreenshot, createFileName } from "use-react-screenshot";
import Item from "antd/lib/list/Item";
import { v4 as uuid } from "uuid";
import Pan from "../forms/canvas/img/pan2.png";
import { useParams } from "react-router-dom";
export type IMyOwnDesignFormProps = {
  handleSceenShortsDamage: any;
  handleChange: any;
  handleImageTypes: (image: { file: any; color: string }) => void;
  deleteImageTypes: any;
  globalData: any;
  mouseClickFrontDamage: (mousePosition: {
    id: string;
    x: number;
    y: number;
    color: string;
  }) => void;

  mouseClickBackDamage: (mousePosition: {
    id: string;
    x: number;
    y: number;
    color: string;
  }) => void;
  initialDesign: any;
  deletePositionFiles: (id: string, attribute: string) => void;
};
// const defaultDamageList = [
//   {
//     id: "0",
//     img: "/damage-assets/1.png",
//     color: "#ff872a",
//     prepareToDelete: false,
//     name: "ab",
//   },
//   {
//     id: "1",
//     img: "/damage-assets/2.png",
//     color: "#06c170",
//     prepareToDelete: false,
//     name: "abc",
//   },
//   {
//     id: "2",
//     img: "/damage-assets/3.png",
//     color: "#7a9ec5",
//     prepareToDelete: false,
//     name: "abcd",
//   },
// ];
const DamageForm: React.FC<IMyOwnDesignFormProps> = ({
  handleSceenShortsDamage,
  handleChange,
  handleImageTypes,
  deleteImageTypes,
  globalData,
  mouseClickFrontDamage,
  mouseClickBackDamage,
  initialDesign,
  deletePositionFiles,
}) => {
  console.log(initialDesign);
  const ref = React.useRef(null);
  const [x, setX] = React.useState<any>(0);
  const [y, setY] = React.useState<any>(0);
  const [position, setPosition] = React.useState(false);
  const [prepareToDelete, setPrepareToDelete] = React.useState(false);
  const [drawerOpened, setDrawerOpened] = React.useState(false);
  const [owndesignlist, setOwnDesignList] = React.useState<any>([]);
  const { selectedProduct } = useSelector((state: any) => state.products);
  const [image, takeScreenshot] = useScreenshot();
  // const { register, control, handleSubmit, watch, errors } = useForm();
  const onSubmit = (data: any) => {
    const myOwnSelectionCustom = {
      frontLeftSelectedTexture: frontLeftSelectedTexture,
      frontRightSelectedTexture: frontRightSelectedTexture,
      backPackSelectedTexture: backPackSelectedTexture,
    };
    const submitData = { ...data, myOwnSelectionCustom };
    setDrawerOpened(false);
  };
  const BackButtonId: any = uuid();
  const FrontButtonId: any = uuid();
  const [openColorsContainer, setOpenColorsContainer] = React.useState(false);
  const [openColorsContainerBack, setOpenColorsContainerBack] =
    React.useState(false);

  const [buttonsAdded, setbuttonsAdded] = React.useState<any>([]);
  const [buttonsAddedBack, setbuttonsAddedBack] = React.useState<any>([]);
  const [selectedTexture, setSelectedTexture] = React.useState<any>(null);
  const [Img, setImg] = React.useState<any>();
  // ;
  const [backPackSelectedTexture, setbackPackSelectedTexture] =
    React.useState<any>();
  const [frontRightSelectedTexture, setfrontRightSelectedTexture] =
    React.useState();
  const [frontLeftSelectedTexture, setfrontLeftSelectedTexture] =
    React.useState();

  const params = useParams<{ status: string }>();
  /////////////////////CAnvaaaaaaaaaaaaaas//////////////////////////////////
  const canvasRefFront = useRef<HTMLCanvasElement>(null);
  const canvasRefBack = useRef<HTMLCanvasElement>(null);

  React.useEffect(() => {
    if (drawerOpened) {
      fetchImageFront();
      fetchImageBack();
    }
  }, [canvasRefFront, selectedProduct, drawerOpened, canvasRefBack]);

  const fetchImageBack = () => {
    if (canvasRefBack && selectedProduct) {
      console.log(canvasRefBack.current);

      if (canvasRefBack.current) {
        const canvas: any = canvasRefBack.current;
        // canvas.toDataURL()
        const context: any = canvasRefBack.current.getContext("2d");
        var imageObj1 = new Image();
        imageObj1.crossOrigin = "Anonymous";
        imageObj1.src =
          process.env.REACT_APP_STORAGE_URL +
          (params.status === "edit"
            ? selectedProduct.original_product.back_image
            : selectedProduct.back_image);

        console.log(canvasRefBack.current);

        //const url=imageObj1Ref.current.currentSrc;
        imageObj1.onload = function () {
          var wrh = imageObj1.width / imageObj1.height;
          var newWidth = canvas.width;
          var newHeight = newWidth / wrh;
          if (newHeight > canvas.height) {
            newHeight = canvas.height;
            newWidth = newHeight * wrh;
          }
          var xOffset =
            newWidth < canvas.width ? (canvas.width - newWidth) / 2 : 0;
          var yOffset =
            newHeight < canvas.height ? (canvas.height - newHeight) / 2 : 0;
          // context.drawImage(imageObj1, xOffset, yOffset, newWidth+20, newHeight);
          context.drawImage(
            imageObj1,
            window.innerWidth < 769 ? xOffset - 80 : xOffset,
            window.innerWidth < 769 ? yOffset - 50 : yOffset,
            window.innerWidth < 769 ? newWidth + 180 : newWidth + 20,
            window.innerWidth < 769 ? newHeight + 120 : newHeight
          );
        };
      }
    }
  };

  const fetchImageFront = () => {
    if (canvasRefFront && selectedProduct) {
      if (canvasRefFront.current) {
        const canvas: any = canvasRefFront.current;
        const context: any = canvasRefFront.current.getContext("2d");
        var imageObj1 = new Image();

        // process.env.REACT_APP_STORAGE_URL + selectedProduct.front_image ;
        // imageObj1.src =`https://cors-anywhere.herokuapp.com/${process.env.REACT_APP_STORAGE_URL + selectedProduct.front_image}`  ;

        // imageObj1.setAttribute('crossOrigin', '');
        //const url=imageObj1Ref.current.currentSrc;
        imageObj1.crossOrigin = "Anonymous";
        //imageObj1.src = process.env.REACT_APP_STORAGE_URL + selectedProduct.front_image  + '?' + new Date().getTime();
        // imageObj1.setAttribute('crossOrigin', '');
        imageObj1.onload = function () {
          var wrh = imageObj1.width / imageObj1.height;
          var newWidth = canvas.width;
          var newHeight = newWidth / wrh;
          if (newHeight > canvas.height) {
            newHeight = canvas.height;
            newWidth = newHeight * wrh;
          }
          var xOffset =
            newWidth < canvas.width ? (canvas.width - newWidth) / 2 : 0;
          var yOffset =
            newHeight < canvas.height ? (canvas.height - newHeight) / 2 : 0;
          context.drawImage(
            imageObj1,
            window.innerWidth < 769 ? xOffset - 80 : xOffset,
            window.innerWidth < 769 ? yOffset - 50 : yOffset,
            window.innerWidth < 769 ? newWidth + 180 : newWidth + 20,
            window.innerWidth < 769 ? newHeight + 120 : newHeight
          );
        };
        imageObj1.src =
          process.env.REACT_APP_STORAGE_URL +
          (params.status === "edit"
            ? selectedProduct.original_product.front_image
            : selectedProduct.front_image);
      }
    }
  };

  // imageObj1.src =Pan
  // process.env.REACT_APP_STORAGE_URL + selectedProduct.front_image; //"/assets/jean-front.png";

  //////////////////////////////////screenshot//////////////////////////////
  const screenShotHandler = React.useCallback(() => {
    const cap: any = document.querySelector("#capture-damage");
    html2canvas(cap, { useCORS: true }).then((canvas) => {
      console.log("canvas", canvas);
      //  document.body.appendChild(canvas)
      var fullQuality = canvas.toDataURL("image/jpeg", 1.0);
      // console.log("fullQuality",fullQuality)
      setImg(fullQuality);
    });

    /* if(selectedProduct){
      if(selectedProduct.front_image)
      {
        takeScreenshot(ref.current);
     //   console.log("images",image)
      }
    }*/
  }, []);
  function dataURLtoFile(image: string, filename: string) {
    var arr: any = image.split(","),
      mime = arr[0].match(/:(.*?);/)[1],
      bstr = atob(arr[1]),
      n = bstr.length,
      u8arr = new Uint8Array(n);

    while (n--) {
      u8arr[n] = bstr.charCodeAt(n);
    }

    return new File([u8arr], filename, { type: mime });
  }
  React.useEffect(() => {
    if (Img) {
      handleSceenShortsDamage("damage_images", [
        dataURLtoFile(
          Img,
          (Math.random() + 1).toString(36).substring(7) + ".jpg"
        ),
      ]);

      // download the image async if we want
      //download(image, { name: "lorem-ipsum", extension: "png" });
      setDrawerOpened(false);
    }
  }, [Img]);
  ////////////////////////////////////////////////////////////////////////////

  const handleFileChange = (event: any) => {
    var generate_color = "#" + (((1 << 24) * Math.random()) | 0).toString(16);

    if (event && event.target && event.target.files && event.target.files[0]) {
      handleImageTypes({ file: event.target.files[0], color: generate_color });

      setOwnDesignList([
        ...owndesignlist,
        {
          img: URL.createObjectURL(event.target.files[0]),
          id: "added",
          name: event.target.files[0].name,
          color: generate_color,
          prepareToDelete: false,
        },
      ]);
    }
  };

  useEffect(() => {
    if (params.status === "edit") {
      initialDesign?.images?.forEach((file: any) => {
        console.log("FILE: ", file);

        let newFile = new File([file], file.name);
        handleImageTypes({ file: newFile, color: file.color });

        setOwnDesignList((x: any) => [
          ...x,
          {
            img: file.preview,
            id: "added",
            name: file.name,
            color: file.color,
            prepareToDelete: false,
          },
        ]);
      });
    }
  }, []);

  useEffect(() => {
    if (params.status === "edit") {
      setPosition(true);
      initialDesign.front.forEach((item: any) => {
        setbuttonsAdded((x: any) => [
          ...x,
          {
            index: item.id,
            color: item.color,
            top: item.y,
            left: item.x,
            prepareToDeleteBtn: false,
          },
        ]);
      });

      initialDesign.back.forEach((item: any) => {
        setbuttonsAddedBack((x: any) => [
          ...x,
          {
            index: item.id,
            color: item.color,
            top: item.y,
            left: item.x,
            prepareToDeleteBtn: false,
          },
        ]);
      });
    }
  }, []);

  /***************************Add Buttons To front image ****************/
  const handleColorsFront = (e: any) => {
    if (owndesignlist.length > 0) {
      const el = e.target;
      offsetX = e.clientX - el.getBoundingClientRect().left;
      offsetY = e.clientY - el.getBoundingClientRect().top;
      setX(offsetX - 10);
      setY(offsetY - 10);
      if (!canvasRefFront.current) {
        return;
      } else {
        const canvas: HTMLCanvasElement = canvasRefFront.current;
        // canvas.toDataURL()
        const context = canvas.getContext("2d");
        if (context) {
          var imgd = context.getImageData(offsetX, offsetY, 1, 1),
            pix = imgd.data;
          for (var i = 0, n = pix.length; i < n; i += 4) {
            if (pix[0] !== 0 && pix[1] !== 0 && pix[2] !== 0 && pix[3] !== 0) {
              setOpenColorsContainer(true);
              setOpenColorsContainerBack(false);
            }
          }
        }
      }
    }
  };
  const addColor = (color: any) => {
    setPosition(true);
    setbuttonsAdded([
      ...buttonsAdded,
      {
        index: FrontButtonId,
        color: color,
        top: y,
        left: x,
        prepareToDeleteBtn: false,
      },
    ]);

    console.log(FrontButtonId, x, y, color);
    mouseClickFrontDamage({ id: FrontButtonId, x: x, y: y, color: color });

    setOpenColorsContainer(false);
    setOpenColorsContainerBack(false);
  };
  //////////////////////////////
  let offsetX: any;
  let offsetY: any;
  //////////////////////////////

  /***************************Add Buttons To Back image ****************/
  const handleColorsBack = (e: any) => {
    if (owndesignlist.length > 0) {
      const el = e.target;
      offsetX = e.clientX - el.getBoundingClientRect().left;
      offsetY = e.clientY - el.getBoundingClientRect().top;
      setX(offsetX - 10);
      setY(offsetY - 10);

      if (!canvasRefBack.current) {
        return;
      } else {
        const canvas: HTMLCanvasElement = canvasRefBack.current;
        const context = canvas.getContext("2d");
        if (context) {
          var imgd = context.getImageData(offsetX, offsetY, 1, 1),
            pix = imgd.data;
          for (var i = 0, n = pix.length; i < n; i += 4) {
            if (pix[0] !== 0 && pix[1] !== 0 && pix[2] !== 0 && pix[3] !== 0) {
              setOpenColorsContainerBack(true);
              setOpenColorsContainer(false);
            }
          }
        }
      }
    }
  };
  /*    if(owndesignlist.length>0)
  {  const el = e.target;
    offsetX = e.clientX - el.getBoundingClientRect().left;
    offsetY = e.clientY - el.getBoundingClientRect().top;
    setX(offsetX);
    setY(offsetY);
    setOpenColorsContainerBack(true);
    setOpenColorsContainer(false);}
  };*/
  const addColorBack = (color: any) => {
    setPosition(true);
    setbuttonsAddedBack([
      ...buttonsAddedBack,
      {
        index: BackButtonId,
        color: color,
        top: y,
        left: x,
        prepareToDeleteBtn: false,
      },
    ]);
    console.log(BackButtonId, x, y, color);
    mouseClickBackDamage({ id: BackButtonId, x: x, y: y, color: color });
    setOpenColorsContainerBack(false);
  };
  /***delete damage*****/
  const deleteDamage = (color: any, item: any) => {
    deleteImageTypes(color, "damage_type_images");
    setOwnDesignList(owndesignlist.filter((el: any) => el.color !== color));
    setbuttonsAdded(buttonsAdded.filter((el: any) => el.color !== color));
    setbuttonsAddedBack(
      buttonsAddedBack.filter((el: any) => el.color !== color)
    );
    setOpenColorsContainer(false);
    setOpenColorsContainerBack(false);
  };
  /*****delete buttons front****/
  const deleteButtonsFront = (id: any) => {
    setbuttonsAdded(buttonsAdded.filter((el: any) => el.index !== id));
    deletePositionFiles(id, "tmp_damage_front");
  };
  /****delete buttons back*****/

  const deleteButtonsBack = (id: any) => {
    setbuttonsAddedBack(buttonsAddedBack.filter((el: any) => el.index !== id));
    deletePositionFiles(id, "tmp_damage_front");
  };

  const clearAll = () => {
    setbuttonsAdded([]);
    setOwnDesignList([]);
    setbuttonsAddedBack([]);
  };

  const [open, setOpen] = React.useState(false);

  const showModal = () => {
    setOpen(true);
  };

  const handleCancel = () => {
    setOpen(false);
  };

  return (
    <div>
      <Row>
        <Col span={24}>
          <LazerOpenModalButton
            title={
              selectedProduct
                ? selectedProduct.fabric_type === "knit"
                  ? "Graphic"
                  : "Damages"
                : "Damages"
            }
            onClick={() => setDrawerOpened(true)}
            type="dammages"
          />
        </Col>
      </Row>
      <Row>
        <textarea
          placeholder="More Details"
          className="textarea-custom"
          onChange={(e: any) => handleChange(e)}
          rows={3}
          name="damage_details"
          value={globalData.damage_details}
        />
      </Row>
      <Drawer
        height={
          window.innerWidth < 769
            ? window.innerHeight - 80
            : window.innerHeight - 100
        }
        placement="bottom"
        title={
          <div className="d-flex justify-content-center align-items-center">
            <h2 className="text-center">
              {selectedProduct
                ? selectedProduct.fabric_type === "knit"
                  ? "Graphic"
                  : "Damages"
                : "Damages"}
            </h2>
            <Space className="ml-auto">
              {/*   <button
                type="reset"
                onClick={() => setDrawerOpened(false)}
                className="order-btn-h outlined-btn-h"
              >
                Close
              </button> */}
              <button
                type="submit"
                onClick={screenShotHandler}
                /*    className="order-btn-h" */
                style={{
                  background: "#00468C",
                  color: "white",
                  borderRadius: 5,
                  height: 40,
                  paddingInline: 24,
                  marginRight: 8,
                  fontSize: "16px",
                }}
              >
                Confirm and close
              </button>
              <button
                type="button"
                onClick={showModal}
                /* className="order-btn-h outlined-btn-h" */
                style={{
                  background: "#e3e0e0",
                  color: "white",
                  borderRadius: 5,
                  height: 40,
                  paddingInline: 16,
                  paddingBottom: 7,
                  fontSize: "16px",
                }}
              >
                <CloseOutlined
                  style={{
                    color: "#00468C",

                    fontSize: "16px",
                  }}
                />
              </button>
            </Space>

            <Modal
              title="Changes not saved"
              visible={open}
              maskClosable={false}
              closable={false}
              centered
              onCancel={handleCancel}
              footer={[
                <button
                  onClick={() => {
                    handleCancel();
                    screenShotHandler();
                  }}
                  key="submit"
                  style={{
                    background: "#00468C",
                    color: "white",
                    borderRadius: 5,
                    height: 40,
                    paddingInline: 24,
                    marginRight: 8,
                  }}
                >
                  Confirm and close
                </button>,

                <button
                  onClick={() => {
                    setDrawerOpened(false);
                    clearAll();
                    handleCancel();
                  }}
                  key="submit"
                  style={{
                    background: "white",
                    border: "1px solid #E0E0E0",
                    borderRadius: 5,
                    height: 40,
                    paddingInline: 24,
                    marginRight: 8,
                  }}
                >
                  Discard changes
                </button>,

                <button
                  key="back"
                  onClick={handleCancel}
                  style={{ borderRadius: 5 }}
                >
                  Cancel
                </button>,
              ]}
            >
              <p>Would you like to confirm your changes?</p>
            </Modal>
          </div>
        }
        visible={drawerOpened}
        closable={false}
        onClose={() => setDrawerOpened(false)}
        // @ts-ignore
        // extra={
        //   <Space>
        //     <button
        //       type="reset"
        //       onClick={() => setDrawerOpened(false)}
        //       className="order-btn-h outlined-btn-h"
        //     >
        //       Discard
        //     </button>
        //     <button
        //       type="submit"
        //       onClick={screenShotHandler}
        //       className="order-btn-h"
        //     >
        //       Confirm
        //     </button>
        //   </Space>
        // }
      >
        {/* <Row justify="center" style={{ width: "100%" }}>
          <h1 className="pt-4">
            {selectedProduct
              ? selectedProduct.fabric_type === "knit"
                ? "The Graphic"
                : "Damages"
              : "Damages"}
          </h1>
          <Divider />
        </Row> */}
        <Row
          className="container-configurator pt-4"
          ref={ref}
          id="capture-damage"
        >
          <div
            className="my-own-design-configurator"
            style={{ marginBottom: "250px" }}
          >
            <div className="my-own-config-col left">
              <div className="m-o-jean-img-container">
                {selectedProduct &&
                  (params.status === "edit"
                    ? selectedProduct.original_product.front_image
                    : selectedProduct.front_image) && (
                    <canvas
                      className="canv"
                      id="canvas"
                      onClick={handleColorsFront}
                      width={
                        window.innerWidth < 769
                          ? window.innerWidth / 2
                          : window.innerWidth / 2 - 105
                      }
                      height={window.innerHeight - 130 - 120}
                      ref={canvasRefFront}
                    />
                  )}

                {position && (
                  <>
                    {buttonsAdded.map((item: any, index: any) => (
                      <button
                        onClick={() => deleteButtonsFront(item.index)}
                        key={index}
                        style={{
                          top: item.top,
                          left: item.left,
                          backgroundColor: item.color,
                        }}
                        className={`circle-btn-shooser orange-btn-c  ${
                          selectedTexture === frontLeftSelectedTexture
                            ? "active"
                            : ""
                        }`}
                      >
                        <DeleteOutlined
                          className="delete-damage-buttons"
                          style={{
                            fontSize: "28px",
                            color: "white",
                            fontWeight: "bold",
                          }}
                        />
                        <div className="damage-indicator">
                          <DamageIndicatorIcon />
                        </div>
                      </button>
                    ))}
                  </>
                )}
                {openColorsContainer && (
                  <div
                    className="colorsContainer"
                    style={{
                      top: y,
                      left: x,
                      backgroundColor: "white",
                    }}
                  >
                    {owndesignlist.map((item: any, index: number) => (
                      <button
                        key={index}
                        onClick={() => addColor(item.color)}
                        style={{ backgroundColor: item.color }}
                        className="circle-btn-shoosers"
                      >
                        <DamageIndicatorIcon />
                      </button>
                    ))}
                  </div>
                )}
              </div>
            </div>

            <div className="m-o-customizer-picker-container">
              <div
                className="scrollable-items-previews d-flex flex-column align-items-center"
                style={{ padding: "10px 0" }}
              >
                {owndesignlist.map((item: any, index: number) => (
                  <div className="btn-with-dot-indicator" key={index}>
                    <button
                      className="btn-damage-chooser-mo"
                      onClick={() => deleteDamage(item.color, item)}
                    >
                      <img
                        className="img-damages"
                        crossOrigin="anonymous"
                        src={item.img}
                        alt={`id alt icon demco${index}`}
                      />
                      <DeleteOutlined
                        className="delete-damage-icon"
                        style={{ fontSize: "24px", color: "white" }}
                      />
                    </button>
                    <Dot color={item.color} />
                  </div>
                ))}
                {owndesignlist.length < 5 && (
                  <div className="upload-ow-design-wrapper">
                    <button className="upload-ow-design-btn">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="18"
                        height="18"
                        viewBox="0 0 18 18"
                      >
                        <path
                          id="Path_3307"
                          data-name="Path 3307"
                          d="M17.625-10.125h-7.5v-7.5A.375.375,0,0,0,9.75-18H8.25a.375.375,0,0,0-.375.375v7.5H.375A.375.375,0,0,0,0-9.75v1.5a.375.375,0,0,0,.375.375h7.5v7.5A.375.375,0,0,0,8.25,0h1.5a.375.375,0,0,0,.375-.375v-7.5h7.5A.375.375,0,0,0,18-8.25v-1.5A.375.375,0,0,0,17.625-10.125Z"
                          transform="translate(0 18)"
                          fill="#00468c"
                        />
                      </svg>
                    </button>
                    <input
                      onChange={handleFileChange}
                      type="file"
                      name="myfile"
                    />
                  </div>
                )}
              </div>
            </div>
            <div className="my-own-config-col right">
              <div className="m-o-jean-img-container">
                {selectedProduct &&
                  (params.status === "edit"
                    ? selectedProduct.original_product.back_image
                    : selectedProduct.back_image) && (
                    <canvas
                      id="canvas-back"
                      onClick={handleColorsBack}
                      width={
                        window.innerWidth < 769
                          ? window.innerWidth / 2
                          : window.innerWidth / 2 - 105
                      }
                      height={window.innerHeight - 130 - 120}
                      ref={canvasRefBack}
                    />
                  )}

                {position && (
                  <>
                    {" "}
                    {buttonsAddedBack.map((item: any, index: any) => (
                      <button
                        onClick={() => deleteButtonsBack(item.index)}
                        key={index}
                        style={{
                          top: item.top,
                          left: item.left,
                          backgroundColor: item.color,
                        }}
                        className={`circle-btn-shooser   ${
                          selectedTexture === backPackSelectedTexture
                            ? "active"
                            : ""
                        }`}
                        //onClick={()=>handleLeftTexture(item.color)}
                      >
                        <DeleteOutlined
                          className="delete-damage-buttons"
                          style={{
                            fontSize: "28px",
                            color: "white",
                            fontWeight: "bold",
                          }}
                        />
                        <div className="damage-indicator">
                          <DamageIndicatorIcon />
                        </div>
                      </button>
                    ))}
                  </>
                )}
                {openColorsContainerBack && (
                  <div
                    className="colorsContainer"
                    style={{
                      top: y,
                      left: x,
                      backgroundColor: "white",
                    }}
                  >
                    {owndesignlist.map((item: any, index: number) => (
                      <button
                        key={index}
                        onClick={() => addColorBack(item.color)}
                        style={{ backgroundColor: item.color }}
                        className="circle-btn-shoosers"
                      >
                        <DamageIndicatorIcon />
                      </button>
                    ))}
                  </div>
                )}
                <div style={{ marginTop: "80px" }}></div>
              </div>
            </div>
          </div>
        </Row>
        {/* <Row
          justify="center"
          align="middle"
          style={{ marginTop: window.innerWidth < 769 ? "7.8rem" : "-1rem" }}
        >
          <Col>
            <button
              type="reset"
              onClick={() => setDrawerOpened(false)}
              className="order-btn-h outlined-btn-h"
            >
              Discard
            </button>
          </Col>
          <Col>
            <button
              type="submit"
              onClick={screenShotHandler}
              className="order-btn-h"
            >
              Confirm
            </button>
          </Col>
        </Row> */}
      </Drawer>
      {/* <Drawer
        className="order_sent_drawer"
        placement={"bottom"}
        closable={true}
        onClose={() => setNotApproveIsVisible(false)}
        visible={notApproveIsVisible}
        key={"bottom"}
      >
        <div className="my-2">
          <h1>Your order has been sent</h1>
          <p>
            We will train you in the coming days on the advancement of your
            product.{" "}
          </p>
        </div>
        <img src={order_sent} alt="order sent" className="img-fluid my-2" />
      </Drawer> */}
      {/* <NotApprovedDrawer
        approved={true}
        notApproveIsVisible={notApproveIsVisible}
        setNotApproveIsVisible={() => setNotApproveIsVisible(false)}
      /> */}
    </div>
  );
};

export { DamageForm };
{
  /*  <img
                  style={{
                  width:window.innerWidth / 2-200 }}
                    onClick={handleColorsFront}
                    src={
                      process.env.REACT_APP_STORAGE_URL +
                      selectedProduct.front_image
                    }
                    alt="demco jean front"
                  />*/
}
